import { BASE_NAME } from "../../constants/FileConstants";
export const ExtractBaseURL = () => {
    const currentURL = window.location.href;
    // const url = new URL(currentURL);
    // const baseURL = `${url.protocol}//${url.host}`;
    let baseURL = currentURL.split(`${BASE_NAME}`)[0];
    // if (baseURL === 'https://totalview.healthos.elevancehealth.com') {
    //     baseURL = 'https://sbx.totalview.healthos.elevancehealth.com'
    // }
    return baseURL;
}
